/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    Device,
    ResponseReason,
} from './';

/**
 * Response with list of devices
 * @export
 * @interface ResponseDeviceListBody
 */
export interface ResponseDeviceListBody {
    /**
     * @type {Array<Device>}
     * @memberof ResponseDeviceListBody
     */
    data?: Array<Device>;
    /**
     * @type {string}
     * @memberof ResponseDeviceListBody
     */
    message?: string;
    /**
     * @type {ResponseReason}
     * @memberof ResponseDeviceListBody
     */
    reason?: ResponseReason;
}
